import ServiceBase from '@/Services/ServiceBase';

export default class DigitalItemDownloadsService extends ServiceBase {
    download(projectID, orderItemID) {
        return this.request('post', 'digitalItemDownloads/download', { projectID, orderItemID });
    }
}